<template>
  <div
    class="bank-management"
    :class="bankCardList.length < 1 && page > 1 ? 'on' : ''"
    ref="container"
  >
    <div class="line" v-if="bankCardList.length > 0">
      <img src="@assets/images/line.jpg" />
    </div>
    <div class="item" v-for="(item, index) in bankCardList" :key="index">
      <div class="bank">
        <router-link :to="{ path: '/user/bank_detail?id=' + item.id }">
          <div class="bank-message acea-row row-between-wrapper">
            <div class="bank-icon"></div>
            <div class="bank-name">
              <div class="consignee">{{ item.bankName }}</div>
              <div>{{ item.bankTypeName }}</div>
            </div>
            <div class="item-bank-id">
              {{ formatterBankId(item.bankId) }}
            </div>
          </div>
        </router-link>
      </div>
      <!-- <div class="operation acea-row row-between-wrapper">
        <div class="select-btn">
          <div class="checkbox-wrapper">
            <label class="well-check"
              ><input
                type="radio"
                name="default"
                value=""
                :checked="item.isDefault ? true : false"
                @click="radioChange(index)"
              /><i class="icon"></i><span class="default">设为默认</span></label
            >
          </div>
        </div>
        <div class="acea-row row-middle">
          <div @click="delBankCard(index)">
            <span class="iconfont icon-shanchu"></span>删除
          </div>
        </div>
      </div> -->
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <div class="noCommodity" v-if="bankCardList.length < 1 && page > 1">
      <div class="noPictrue">
        <img src="@assets/images/noBank.png" class="image" />
      </div>
    </div>
    <div style="height:1.2rem;"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="bankBnt on bg-color-red add-bank" @click="addBankCard">
        <div>
          <img src="@assets/images/bank.png" alt="" />
        </div>
        <div>
          添加新的银行卡
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.bank-management.on {
  background-color: #fff;
  height: 100vh;
}
</style>
<script type="text/babel">
import {
  getBankCardList,
  getBankCardRemove,
  getBankCardDefaultSet,
  isIdent
} from "@api/user";
import Loading from "@components/Loading";
import { isWeixin } from "@utils";

export default {
  components: {
    Loading
  },
  data() {
    return {
      page: 1,
      limit: 20,
      bankCardList: [],
      loadTitle: "",
      loading: false,
      loadend: false,
      isWechat: isWeixin()
    };
  },
  mounted: function() {
    this.BankCardList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.BankCardList();
    });
  },
  methods: {
    /**
     * 获取地址列表
     *
     */
    BankCardList: function() {
      let that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      getBankCardList({ page: that.page, limit: that.limit }).then(res => {
        that.loading = false;
        //apply();js将一个数组插入另一个数组;
        that.bankCardList.push.apply(that.bankCardList, res.data);
        that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    },
    formatterBankId(bankId) {
      return `···· ···· ···· ${bankId}`;
    },
    /**
     * 删除地址
     */
    delBankCard: function(index) {
      this.$dialog.confirm({
        mes: "确认删除该银行卡吗?",
        opts: () => {
          let that = this;
          let bankCard = this.bankCardList[index];
          let id = bankCard.id;
          getBankCardRemove(id).then(function() {
            that.$dialog.toast({
              mes: "删除成功!",
              callback: () => {
                that.bankCardList.splice(index, 1);
                that.$set(that, "bankCardList", that.bankCardList);
              }
            });
          });
        }
      });
    },
    /**
     * 设置默认地址
     */
    radioChange: function(index) {
      let that = this,
        bankCard = this.bankCardList[index],
        id = bankCard.id;
      getBankCardDefaultSet(id).then(function() {
        for (var i = 0, len = that.bankCardList.length; i < len; i++) {
          if (i === index) that.bankCardList[i].is_default = 1;
          else that.bankCardList[i].is_default = 0;
        }
        that.$set(that, "bankCardList", that.bankCardList);
      });
    },
    /**
     * 新增银行卡
     */
    addBankCard: function() {
      isIdent().then(
        res => {
          this.$router.push({
            path: "/user/add_bank_card"
          });
        },
        error => {
          this.$vantDialog
            .confirm({
              title: "",
              message: "您还未实名认证，是否去认证",
              className: "errorPayment",
              confirmButtonText: "去认证",
              confirmButtonColor: "red",
              cancelButtonText: "取消",
              cancelButtonColor: "black"
            })
            .then(() => {
              this.$router.push({
                path: "/user/identification"
              });
            })
            .catch(() => {});
        }
      );
    }
  }
};
</script>
<style scoped>
.add-bank {
  display: flex;
  flex-flow: nowrap;
  justify-content: center;
}
.add-bank div:first-child {
  line-height: 0.76rem;
  height: 0.76rem;
  text-align: center;
  margin-right: 0.1rem;
}
.add-bank img {
  width: 0.5rem;
  height: 0.5rem;
  margin-top: 0.13rem;
}
</style>
